/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IUserCellProps } from './types';
import { CircularAvatar } from '../../../../../CustomAvatar';
import { meetingSimpleSelectors } from '../../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { isMemberPartOfMeeting, isMemberActiveInWorkspace } from '../../../../../../../../utils/user.utils';

export const UserCell: FunctionComponent<IUserCellProps> = ({ userId, meetingId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  return (
    user &&
    meeting && (
      <div className="account-item">
        <CircularAvatar
          src={user.image}
          title={`${user.firstName} ${user.lastName}`}
          classes={`small-avatar mr-05 ${
            !isMemberPartOfMeeting(user, meeting) || !isMemberActiveInWorkspace(user) ? 'deleted-user' : ''
          }`}
          cursorPointer={false}
        />
        <div className="account-item-desc">
          <h3 className="account-item-title">{`${user.firstName} ${user.lastName}`}</h3>
        </div>
      </div>
    )
  );
};
